import { supabase } from "@/integrations/supabase/client";

/**
 * Fetch the sets of seller `user_id`s that qualify as Verified Sellers,
 * Official Partners and Featured Shops. Used by the Browse page's trust
 * filters — reads the same tables the badge stack does, so results stay
 * consistent everywhere.
 */
export type TrustSellerSets = {
  verified: Set<string>;
  officialPartners: Set<string>;
  featuredShops: Set<string>;
};

export async function fetchTrustSellerSets(): Promise<TrustSellerSets> {
  const [verifiedRes, partnersRes, shopsRes] = await Promise.all([
    supabase
      .from("seller_trust_badges")
      .select("user_id")
      .eq("status", "active")
      .eq("badge_type", "verified_seller"),
    supabase
      .from("public_business_partners" as never)
      .select("linked_profile_id")
      .eq("is_official_partner", true)
      .not("linked_profile_id", "is", null),
    supabase.from("public_featured_shops").select("profile_id"),

  ]);
  const verified = new Set<string>(
    ((verifiedRes.data ?? []) as { user_id: string }[]).map((r) => r.user_id),
  );
  const officialPartners = new Set<string>(
    ((partnersRes.data ?? []) as { linked_profile_id: string | null }[])
      .map((r) => r.linked_profile_id)
      .filter((v): v is string => !!v),
  );
  const featuredShops = new Set<string>(
    ((shopsRes.data ?? []) as { profile_id: string }[]).map((r) => r.profile_id),
  );
  return { verified, officialPartners, featuredShops };
}
